import { SelectionData } from '../../../models/util.model'
import { PermissionsScope } from '../../policies/policy.model'
import { UserHomeModule, UserTab, UserType } from '../models/user.types'

export const USER_FRAGMENT = 'user'
export const USER_SCOPE: PermissionsScope = 'iam'

export const USER_TYPES: SelectionData<UserType>[] = [
  {
    label: 'Utente',
    value: 'HUMAN',
    icon: 'fad fa-user-astronaut',
  },
  {
    label: 'Bot',
    value: 'SERVICE',
    icon: 'fad fa-user-robot',
  },
]

export const USER_TABS: SelectionData<UserTab>[] = [
  {
    value: 'general',
    label: 'Generale',
    types: ['HUMAN', 'SERVICE'],
  },
  {
    value: 'tenant',
    label: 'Tenant',
    types: ['HUMAN'],
  },
  {
    value: 'policies',
    label: 'Permessi',
    types: ['HUMAN', 'SERVICE'],
    hideOnProfile: true,
  },
  {
    value: 'security',
    label: 'Sicurezza',
    types: ['HUMAN'],
  },
]

export const USER_HOME_MODULES: SelectionData<UserHomeModule>[] = [
  { value: 'GOODS_RECEIVES', label: 'Arrivi merce' },
  { value: 'PICKING_LISTS', label: 'Picking lists' },
  { value: 'ORDERS', label: 'Ordini' },
  { value: 'PRODUCTS', label: 'Prodotti' },
  { value: 'REPLENISHMENTS', label: 'Missioni di abbassamento' },
  { value: 'LOCATIONS', label: 'Ubicazioni' },
]
